'use client';

import { useEffect, useState } from 'react';
import { BarChart3, Scale } from 'lucide-react';
import { avisoError } from '@/lib/avisoCentral';
import HeroVista from '@/components/HeroVista';
import { cargaLaboral, type CargaLaboral as Carga } from '@/lib/expedientes';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export default function CargaLaboral() {
  const [carga, setCarga] = useState<Carga | null>(null);
  const [cargando, setCargando] = useState(true);

  async function cargar() {
    setCargando(true);
    try {
      setCarga(await cargaLaboral());
    } catch (e) {
      avisoError('No se pudo cargar la carga laboral', e instanceof Error ? e.message : undefined);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  const filas = carga?.filas ?? [];

  return (
    <div className="space-y-6">
      <HeroVista
        icono={BarChart3}
        titulo="Carga laboral"
        descripcion="Distribución de expedientes por funcionario de instrucción. Sirve para equilibrar el reparto."
      />

      {carga?.alerta && (
        <Card className="border-destructive/40 bg-destructive/5">
          <CardContent className="flex items-start gap-3 pt-6 text-sm text-destructive">
            <Scale className="mt-0.5 size-5 shrink-0" />
            <span>{carga.alerta}</span>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardHeader>
          <CardTitle>Expedientes por funcionario</CardTitle>
        </CardHeader>
        <CardContent>
          {cargando ? (
            <p className="py-8 text-center text-sm text-muted-foreground">Cargando…</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Funcionario</TableHead>
                  <TableHead className="text-right">Expedientes asignados</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filas.map((f) => (
                  <TableRow key={f.funcionarioId}>
                    <TableCell>{f.funcionario}</TableCell>
                    <TableCell className="text-right font-medium">{f.total}</TableCell>
                  </TableRow>
                ))}
                {filas.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2} className="py-8 text-center text-muted-foreground">
                      Sin datos de carga laboral.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
